import { getClient } from './client'

let cachedLoginAd: string

export const getLoginAd = async (): Promise<string> => {
  if (cachedLoginAd) {
    return cachedLoginAd
  }

  try {
    const client = getClient()
    const response = await client.get('/ads/login')
    cachedLoginAd = response.data
    return response.data
  } catch (error: any) {
    throw Error(formatError(error))
  }
}

const formatError = (error: any) => {
  let errorMessage
  if (error.response) {
    errorMessage = error.response?.data?.message
      ? error.response?.data?.message
      : 'UNKNOWN_SERVER_ERROR'
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    errorMessage = 'NO_RESPONSE_FROM_SERVER'
  } else {
    // Something happened in setting up the request that triggered an Error
    errorMessage = error.message
  }
  return errorMessage
}
